import { API_ROUTES, IListingRequestParams } from "@tm/api-utils";
import { CONTEXT, LOB, PARTNER, PLATFORM } from "@tm/isomorphic-utils";
import {
  getHTTPRoutePrefix,
  getLobOnServerSide,
  getPathPartnerOnServerSide,
} from "@tm/server-utils";
import { API_HTTP } from "../apiInstance";
import { setURLQueryParams } from "../setURLQueryParams";
import { getMyPartnerMockListing } from "./getMyPartnerMockListing";

export const getProductListing = async (reqData: IListingRequestParams) => {
  let { partner = PARTNER.MMT } = reqData;
  const { headers, cmp, query, dvid, ...data } = reqData;

  // Check for MOCK_CLIENT_PARTNER environment variable first
  //TODO: CLEANUP: Remove mock client partner and also libs/server-api-utils/src/apiRoutes/mocks post mybiz merge to release
  if (process.env["MOCK_CLIENT_PARTNER"]) {
    const mockPartner = process.env["MOCK_CLIENT_PARTNER"];
    // Validate that the mock partner is a valid partner value
    const validPartners = Object.values(PARTNER) as string[];
    if (validPartners.includes(mockPartner)) {
      partner = mockPartner as any;
    }
    return getMyPartnerMockListing(reqData);
  }

  // For other partners, use regular API call
  const params = {
    lob: getLobOnServerSide(partner) || LOB.STANDALONE,
    platform: PLATFORM.WEB,
    context: CONTEXT.STANDALONE_V2,
    isCountryCodesSupported: true,
    partner,
    ...query,
  };

  const urlParams = setURLQueryParams(params);
  const httpRoutePrefix = getHTTPRoutePrefix(partner);
  const pathPartner = getPathPartnerOnServerSide(partner);

  const response = await API_HTTP.post(
    `${httpRoutePrefix}/${pathPartner}/${API_ROUTES.GET_PRODUCT_LISTING}${
      urlParams ? `?${urlParams}` : ""
    }`,
    data,
    {
      headers: { ...headers, cmp: cmp || query?.["cmp"] || "fallback", dvid },
    }
  );
  return response;
};
